export default "__VITE_ASSET__wtNACyEi__"